import { type ReactNode, useState } from "react";

import { lazyOverlay, useLazyOverlay } from "../lib/lazyOverlay.js";
import { ProfileContext } from "../lib/profile.js";

const ProfileDialog = lazyOverlay(() =>
  import("./ProfileDialog.js").then((module) => module.ProfileDialog),
);

/**
 * Renders the player profile dialog once, inside the root route (`App.tsx`), and provides
 * `showProfile` to open it: a seat on any surface calls `useProfile().showProfile(seat.endUser.id)`.
 * It sits under the router, unlike `RevealClaimProvider`, because the dialog links to the Account
 * page. The dialog's code loads the first time a profile is asked for.
 */
export function ProfileProvider({ children }: { children?: ReactNode }) {
  const [endUserId, setEndUserId] = useState<string | null>(null);
  const Dialog = useLazyOverlay(ProfileDialog, endUserId !== null, () => setEndUserId(null));

  return (
    <ProfileContext.Provider value={{ showProfile: setEndUserId }}>
      {children}
      {Dialog && <Dialog endUserId={endUserId} onClose={() => setEndUserId(null)} />}
    </ProfileContext.Provider>
  );
}
